import fp from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { updateOutreachAggregateReportQuery } from '../../../actions/report';
import { fetchReportForOutreachAggregate } from '../../../sagas/report/routines';

const reduce = fp.reduce.convert({ cap: false });
const initialState = {
  query: {},
  result: [],
  fetching: false,
  fetchingError: null
};

const fetchReportHandler = routine => ({
  [routine.TRIGGER]: fp.set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const SUMMABLE_COLUMNS = ['household_total'];
    const isSumableColumn = fp.includes(SUMMABLE_COLUMNS);
    const formattedItems = fp.map(
      reduce((newItem, each, column) => {
        if (fp.isObject(each)) {
          const { value, groupBy } = each;
          const groupByProp = groupBy ? { [`${column}_group`]: groupBy } : {};
          const valueProp = () => {
            if (fp.isUndefined(value)) return {};
            const suffix = isSumableColumn(column) ? 'sum' : 'count';
            const key = groupBy ? `${column}_${suffix}` : column;
            return { [key]: value };
          };
          return { ...newItem, ...groupByProp, ...valueProp() };
        }
        return fp.set(column, each, newItem);
      }, {})
    )(response.items);
    return fp.set('result', formattedItems, state);
  },
  [routine.FAILURE]: (state, { error }) =>
    fp.set('fetchingError', error, state),
  [routine.FULFILL]: fp.set('fetching', false)
});

const updateReportQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) =>
    fp.set('query', query, state)
});

export default createReducer(initialState, {
  ...fetchReportHandler(fetchReportForOutreachAggregate),
  ...updateReportQueryHandler(updateOutreachAggregateReportQuery)
});
